import { useCheckResources } from '@katalon-studio/pdp-react';
import { useEffect, useState } from 'react';
import { CheckResourcesResponse } from '@katalon-studio/pdp-react/types/checkResponse';
import { PermissionAction, ResourcePolicy } from '../models/permission';
import { Account } from '../models';

export const useCheckPermission = (account: Account) => {
  // in development mode, we skip checking permission,
  // otw, we're already filter the g2 account when fetching the account list
  // so we don't need to check permission for g2 account here
  if (process.env.NODE_ENV === 'development' || !account.g3) {
    return { allowed: true, loading: false };
  }

  const [allowed, setAllowed] = useState(false);
  const [loading, setLoading] = useState(true);

  const permissionCheckResponse = useCheckResources(
    {
      resources: [{
        resource: {
          kind: ResourcePolicy.SUBSCRIPTION,
        },
        actions: Object.values(PermissionAction),
      }],
    },
    account.id,
  );

  useEffect(() => {
    if (!permissionCheckResponse.isLoading && permissionCheckResponse?.data) {
      const checkResponse = (permissionCheckResponse.data as any) as CheckResourcesResponse;
      const checkResult = checkResponse.results
        ?.some(resourceActionsResponse => Object.entries(resourceActionsResponse.actions)
          .some(([, effect]) => effect.toString() === 'EFFECT_ALLOW'));
      setAllowed(checkResult);
      setLoading(false);
    }
  }, [permissionCheckResponse]);

  return { allowed, loading };
};
